import { CardElement,useStripe,useElements} from '@stripe/react-stripe-js';
import React,{useState,useEffect} from 'react'
import {Link,useHistory} from 'react-router-dom'
import CheckoutProduct from './CheckoutProduct';
import './Payment.css'
import {useStateValue} from './StateProvider'
import { NumericFormat } from "react-number-format";
import { getBasketTotal } from './reducer';
import axios from './axios'
import swal from 'sweetalert';
import {db} from './firebase'


function Payment() {
    const [{basket,user},dispatch]=useStateValue();
    const history=useHistory();
    const stripe=useStripe();
    const elements=useElements();
    const [succeeded,setSucceeded]=useState(false);
    const [processing,setProcessing]=useState(false);
    const [error,setError]=useState(null);
    const [disabled,setDisabled]=useState(true);
    const [clientSecret,setClientSecret]=useState(localStorage.getItem('clientSecret')?localStorage.getItem('clientSecret'):undefined);
    const [address,setAddress]=useState(null)
    const [fname,setFName]=useState(null)
    const [lname,setLName]=useState(null)
    const [contact,setContact]=useState(null)

    useEffect(() => {
        if(user){
            db.collection('users')
            .doc(user.email)
            .get().then((doc)=>{
                if(doc.exists){
                    setFName(doc.data().fname)
                    setLName(doc.data().lname)
                    setContact(doc.data().contact)
                    setAddress(doc.data().address)
                }
            }).catch((err)=>{
                console.log('err is ',err)
            })
        }
    }, [user])

    const handleSubmit=async(event)=>{
        event.preventDefault();
        if(!address||!fname||!lname||!contact){
            swal("","Something missing in address, Full Name or contact. Please update these details in Profile","error")
        }
        else{
            setProcessing(true);
        setError('')
        let prevCart=localStorage.getItem('prevCart');
        const prevCartParsed = JSON.parse(prevCart);
        if(clientSecret&&(JSON.stringify(basket)===JSON.stringify(prevCartParsed))){
                await stripe.confirmCardPayment(clientSecret,{
                    payment_method:{
                        card:elements.getElement(CardElement),
                        billing_details:{
                            address:{
                                line1:address
                            },
                            email:user.email,
                            name:`${fname} ${lname}`,
                            phone:contact
                        }
                    },
                    receipt_email:user.email
                }).then(({paymentIntent,error})=>{
                    if(error){
                        setError(error.message)
                        setTimeout(() => {
                            setError(null)
                        }, 5000);
                        setProcessing(false)
                    }
                    if(paymentIntent){
                        db.collection('users')
                            .doc(user?.email)
                            .update({ "test": "test" })
                            .then(
                                db.collection('users')
                                    .doc(user?.email)
                                    .collection('orders')
                                    .doc(paymentIntent.id)
                                    .set({
                                        basket: basket,
                                        amount: paymentIntent.amount,
                                        customer:[{
                                            "fname":fname,
                                            "lname":lname,
                                            "contact":contact,
                                            "address":address,
                                            "email":user.email,
                                            "status":'Pending'
                                        }],
                                        created: paymentIntent.created
                                    })
                        )
                        axios({
                            url:'/products/update/order/stock',
                            method:'post',
                            data:basket
                        })
                    setSucceeded(true);
                    setError(null)
                    setProcessing(false)
                    localStorage.setItem('clientSecret',undefined)
        
                    dispatch({
                        type:'EMPTY_BASKET'
                    })
                    history.replace('/orders')  
                    }
        
                    }
                )
                .catch(err=>{console.log(err);setProcessing(false)})

        }
        else{
            localStorage.setItem('prevCart',JSON.stringify(basket))
            await axios({
                           method:'post',
                           url:`/payments/create?total=${Math.round(getBasketTotal(basket)*100)}`
                       })
                       .then(async res=>{
                        setClientSecret(res.data.clientSecret)
                        localStorage.setItem('clientSecret',res.data.clientSecret)
                        await stripe.confirmCardPayment(res.data.clientSecret,{
                            payment_method:{
                                card:elements.getElement(CardElement),
                                billing_details:{
                                    address:{
                                        line1:address
                                    },
                                    email:user.email,
                                    name:`${fname} ${lname}`,
                                    phone:contact
                                }
                            },
                            receipt_email:user.email
                        }).then(({paymentIntent,error})=>{
                            if(error){
                                setError(error.message)
                                setTimeout(()=>{
                                    setError(null)
                                },5000)
                                setProcessing(false)
                            }
                            if(paymentIntent){
                                db.collection('users')
                                .doc(user?.email)
                                .update({ "test": "test" })
                                .then(
                                    db.collection('users')
                                        .doc(user?.email)
                                        .collection('orders')
                                        .doc(paymentIntent.id)
                                        .set({
                                            basket: basket,
                                            amount: paymentIntent.amount,
                                            customer:[{
                                                "fname":fname,
                                                "lname":lname,
                                                "contact":contact,
                                                "address":address,
                                                "email":user.email,
                                                "status":'Pending'
                                            }],
                                            created: paymentIntent.created
                                        })
                                    )
                                axios({
                                    url:'/products/update/order/stock',
                                    method:'post',
                                    data:basket
                                })
                            setSucceeded(true);
                            setError(null)
                            setProcessing(false)
                            localStorage.setItem('clientSecret',undefined)
                            dispatch({
                                type:'EMPTY_BASKET'
                            })
                            history.replace('/orders')  
                            }

                            }
                        )
                        .catch(err=>{console.log(err);setProcessing(false)})
                       })
                       .catch(err=>{
                        console.log('Error in payment request:',err)
                        setError('failed to geneate payment secret')
                       })
        }
        }
    }
    const handleChange=event=>{
        setDisabled(event.empty);
        setError(event.error?event.error.message:"");
    }

    return (
        
        <div className="payment">
            <div className='payment__container'>
                <h1>
                    Checkout <Link to="/checkout">{basket?.length} item(s)</Link>
                </h1>
                <div className='payment__section row'>
                    <div className='payment__title col-sm-12'>
                        <h3>Delivery details</h3>
                    </div>
                    <div className='payment__address col-sm-12'>
                        <p>{fname} {lname} {`(${user?.email})`}</p>
                        <p>Contact : {contact}</p>
                        <p>Address : {address}</p>
                    </div>
                </div>
                <div className='payment__section row'>
                    <div className='payment__title col-sm-12'>
                        <h3>Review item</h3>
                    </div>
                    <div className='payment__items col-sm-12'>
                        {basket?.map(item =>(
                            item.count>0&&
                            <CheckoutProduct key={item.id}
                            id={item.id}
                            title={item.title}
                            image={item.image}
                            price={item.price}
                            rating={item.rating}
                            count={item.count}
                            />
                        ))}
                    </div>
                </div>
                <div className='payment__section row'>
                    <div className='payment__title col-sm-12'>
                        <h3>Payment Method</h3>
                    </div>
                    <div className='payment__details col-sm-12'>
                        <form onSubmit={handleSubmit}>
                            <CardElement onChange={handleChange}/>
                            <div className="payment__priceContainer">
                            <NumericFormat
                                renderText={(value)=>(
                                    <h3>Order Total : {value}</h3>
                                )}
                                decimalScale={2}
                                value={getBasketTotal(basket)}
                                displayType={"text"}
                                thousandSeparator
                                prefix={"₹"}
                          />
                          <button disabled={error||processing || disabled ||succeeded}>
                                <span>{processing ?<p className=" mt-1 spinner-border spinner-border-sm text-primary"></p>:"Buy Now"}</span>
                          </button>
                            </div>
                            {error&&<div>{error}</div>}
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Payment;
